import { render, staticRenderFns } from "./SupplierFields.vue?vue&type=template&id=0c331256"
import script from "./SupplierFields.vue?vue&type=script&lang=js"
export * from "./SupplierFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports